import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CorrectionsConsigneeGetForm } from '@corrections/corrections-form/shared/form/consignee/corrections-form-consignee-get-form-groups.utils';
import { ErrorModel } from '@shared/models/shared/error.model';
import { RatingCountryCdEnum } from '@xpo-ltl/rating';

@Injectable()
export class ConsigneeValidatorsService {

  constructor() { }

  requiredFields(form: FormGroup): ErrorModel[] {
    const consigneeForm = CorrectionsConsigneeGetForm.getForm(form);
    const consigneeControls = CorrectionsConsigneeGetForm.getFormValues(consigneeForm);

    // NOTE: The mandatory fields only applies when there is a mad code
    if (!consigneeControls.madCode.value) return [];

    const mandatoryEmptyFields = [];
    if(!consigneeControls.nameOne.value) {
      mandatoryEmptyFields.push('name');
    }

    if(!consigneeControls.address.value) {
      mandatoryEmptyFields.push('address');
    }

    if(!consigneeControls.country.value) {
      mandatoryEmptyFields.push('country');
    }

    if(!consigneeControls.city.value) {
      mandatoryEmptyFields.push('city');
    }

    if(!consigneeControls.state.value) {
      mandatoryEmptyFields.push('state');
    }

    if(!consigneeControls.zipCode.value) {
      mandatoryEmptyFields.push('zipCode');
    }

    if (mandatoryEmptyFields.length === 0) return [];

    const errorMessage = mandatoryEmptyFields.length === 1 ? `Consignee required field` : `Consignee required fields`;
    const errors: ErrorModel[] = [
      {
        message: `${errorMessage}: ${mandatoryEmptyFields.join(', ')}`
      }
    ];
    return errors;
  }

  isMexico(form: FormGroup): boolean {
    const consigneeForm = CorrectionsConsigneeGetForm.getForm(form);
    const consigneeControls = CorrectionsConsigneeGetForm.getFormValues(consigneeForm);
    return consigneeControls.country.value === RatingCountryCdEnum.mx;
  }
}
